import { DateRangePicker, Icon, InputTypes, Radio, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Flex, Text } from 'native-base';
import React, { useMemo } from 'react';

import { LimitedOptionRange, Option } from '../Statements/Header';

interface SelectPeriodProps {
  title: string;
  options: Option[];
  onChange: (value: string) => void;
  selectedValue: string;
  isDisabled?: boolean;
  onClickPeriodInputDate?: () => void;
  onSelectDates: (initialDate: Date, finalDate: Date) => void;
  startDate: Date;
  endDate: Date;
  dateRangePickerIsDisabled?: boolean;
  limitDateRange?: LimitedOptionRange;
}

export const SelectPeriod: React.FC<SelectPeriodProps> = ({
  options,
  onChange,
  selectedValue,
  title,
  isDisabled = false,
  onClickPeriodInputDate,
  onSelectDates,
  startDate,
  endDate,
  dateRangePickerIsDisabled = false,
  limitDateRange,
}) => {
  const normalizedOptions = useMemo(() => {
    return options.map((option) => ({
      ...option,
      disabled: isDisabled,
    }));
  }, [options, isDisabled]);

  return (
    <HStack alignItems="center" space={Spacing['inset.xs']}>
      <HStack space={Spacing['inline.quarck']} alignItems="center">
        <Icon name="Calendar" color={Color['neutral.medium']} size="xxxxs" />
        <Text
          variant="regular"
          fontSize={Typography['fontsize.md']}
          color="neutral.medium"
          numberOfLines={1}>
          {title}
        </Text>
      </HStack>
      <Radio
        testID="period-radio-option"
        options={normalizedOptions}
        onChange={onChange}
        selectedValue={selectedValue}
        textComponentProps={{
          variant: 'semibold',
        }}
        radioComponentProps={{
          size: 'sm',
        }}
      />
      <Text
        variant="regular"
        fontSize={Typography['fontsize.md']}
        color="neutral.medium"
        noOfLines={1}>
        Filtre por data:
      </Text>
      <Flex maxW="230px" minW="230px" flex={1}>
        <DateRangePicker
          onClear={() => {}}
          initialDate={startDate}
          isDisabled={dateRangePickerIsDisabled}
          finalDate={endDate}
          placeholder="Data atual"
          onSelectDates={onSelectDates}
          calendarPosition="right"
          availableRange={limitDateRange}
          inputComponentProps={
            {
              onClick: onClickPeriodInputDate,
            } as InputTypes.Props
          }
        />
      </Flex>
    </HStack>
  );
};
